export const getActionCardClass = (state: string): string => {
  let baseClass = "py-3 px-4 rounded-lg text-sm cursor-pointer relative";

  if (state === "queued" || state === "pending")
    return `${baseClass} bg-warning-100 border border-transparent text-neutral-200 shadow-lg hover:border-warning-200 hover:bg-warning-100-hover`;
  if (state === "processing")
    return `${baseClass} bg-primary-300 border-primary-300 text-white shadow-lg`;
  if (state === "processed" || state === "completed")
    return `${baseClass} bg-success-200 border-success-200 text-neutral-white shadow-lg`;
  if (state === "failed")
    return `${baseClass} bg-danger-200 border-danger-200 text-white shadow-lg`;

  return `${baseClass} bg-compass-bg text-compass-text border border-transparent hover:border-compass-text hover:bg-compass-bg-hover`;
};

export const getMarkdownColorClass = (state: string): string => {
  if (state === "queued" || state === "pending") return "text-neutral-200";
  if (state === "processing") return "text-white";
  if (state === "processed" || state === "completed") return "text-neutral-white";
  if (state === "failed") return "text-white";
  return "text-compass-text";
};
